import GeoJSON from 'ol/format/GeoJSON'

class GeoJSONAPI
{
    constructor()
    {
        this.stateUrl = `/static/layers/state.geojson`;
        this.districtUrl = `/static/layers/district.geojson`;
        this.muniUrl = `/static/layers/gn.geojson`;
        this.parser = new GeoJSON();
    }

    async getFeatures(fullUrl)
    {
        const res = await fetch(fullUrl);
        const geojson = await res.json();
        return this.parser.readFeatures(geojson);
    }

    async getStates()
    {
        return await this.getFeatures(this.stateUrl);
    }

    async getDistricts()
    {
        return await this.getFeatures(this.districtUrl);
    }

    async getMunicipalities()
    {
        return await this.getFeatures(this.muniUrl);
    }
}

const api = new GeoJSONAPI();
let STATE_FEATURES_CACHE;
let DISTRICT_FEATURES_CACHE;
let MUNICIPALITY_FEATURES_CACHE;

export const getStateFeatures = async () =>
{
    if(!STATE_FEATURES_CACHE)
    {
        STATE_FEATURES_CACHE = await api.getStates();
    }
    return STATE_FEATURES_CACHE;
};

export const getDistrictFeatures = async () =>
{
    if (!DISTRICT_FEATURES_CACHE)
    {
        DISTRICT_FEATURES_CACHE = await api.getDistricts();
    }
    return DISTRICT_FEATURES_CACHE;
};

export const getMunicipalityFeatures = async () =>
{
    if (!MUNICIPALITY_FEATURES_CACHE)
    {
        MUNICIPALITY_FEATURES_CACHE = await api.getMunicipalities();
    }
    return MUNICIPALITY_FEATURES_CACHE;
};

getDistrictFeatures();
getMunicipalityFeatures();
